import React, { useState, useEffect } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
import { NAV_LINKS, goToApp } from '../constants';
import Button from './ui/Button';
import Logo from './ui/Logo';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,padding,box-shadow] duration-300 ${
        isScrolled || open ? 'bg-[#0b0814]/90 backdrop-blur-xl py-3 shadow-[0_1px_0_rgba(255,255,255,0.06)]' : 'py-5'
      }`}
      data-testid="navbar"
    >
      <div className="mx-auto max-w-7xl px-6 flex items-center justify-between">
        <Logo />

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <a key={link.name} href={link.href} className="text-sm font-medium text-white/80 hover:text-white transition-colors" data-testid={`nav-link-${link.href.slice(1)}`}>
              {link.name}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Button variant="outlineDark" size="sm" className="px-5" onClick={goToApp} data-testid="nav-login-btn">Log in</Button>
          <Button size="sm" className="px-5" onClick={goToApp} data-testid="nav-get-started-btn">
            Start Creating Free <ArrowRight size={16} />
          </Button>
        </div>

        <button className="lg:hidden text-white p-2" onClick={() => setOpen(!open)} aria-label="Toggle menu" data-testid="nav-mobile-toggle">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <div className={`lg:hidden overflow-hidden transition-[max-height,opacity] duration-300 ${open ? 'max-h-[480px] opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="flex flex-col px-6 pt-4 pb-6 gap-4">
          {NAV_LINKS.map((link) => (
            <a key={link.name} href={link.href} className="text-base font-medium text-white/80 hover:text-white" onClick={() => setOpen(false)}>
              {link.name}
            </a>
          ))}
          <div className="h-px bg-white/10" />
          <Button variant="outlineDark" onClick={goToApp} data-testid="nav-mobile-login-btn">Log in</Button>
          <Button onClick={goToApp} data-testid="nav-mobile-get-started-btn">Start Creating Free <ArrowRight size={16} /></Button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
